import { useState } from 'react';
import html2canvas from 'html2canvas';

interface TakeScreenShotProps {
  cbOnComplete?: (image: string) => void;
}

interface TakeScreenShot {
  (props: TakeScreenShotProps): Promise<string | void>;
}

interface downloadScreenshotProps {
  imageToDownload: string | undefined;
  name?: string;
  extension?: string;
}

interface CreateFullPageSnapshotReturn {
  image: string | null;
  takeScreenShot: TakeScreenShot;
  error: Error | null;
  download: (props: downloadScreenshotProps) => void;
}

const useCreateFullPageSnapShot = (): CreateFullPageSnapshotReturn => {
  const [image, setImage] = useState<string | null>(null);
  const [error, setError] = useState<Error | null>(null);

  const takeScreenShot: TakeScreenShot = async ({ cbOnComplete }) => {
    try {
      const body = document.documentElement; // Captures full HTML document
      const canvas = await html2canvas(body, {
        useCORS: true, // Ensures images load correctly
        scrollX: 0,
        scrollY: 0,
        windowWidth: document.documentElement.scrollWidth,
        windowHeight: document.documentElement.scrollHeight + 800,
      });

      const imgData = canvas.toDataURL('image/png');
      setImage(imgData);
      if (cbOnComplete) {
        cbOnComplete(imgData);
      }

      return imgData;
    } catch (err) {
      setError(err as Error);
      throw err;
    }
  };

  const download = ({
    name = 'screenshot',
    extension = 'png',
    imageToDownload = undefined,
  }: downloadScreenshotProps) => {
    if (!imageToDownload) {
      throw new Error('No image to download');
    }

    const link = document.createElement('a');
    link.href = imageToDownload;
    link.download = `${name}.${extension}`;
    link.click();
  };

  return {
    image,
    takeScreenShot,
    error,
    download,
  };
};

export { useCreateFullPageSnapShot };
